const releaseNoteDialog = {
  "release-notes.dialog.version": "Versión {{ version }}",
};

export default releaseNoteDialog;
